import AbstractField from "./AbstractField";

export default class Buttons extends AbstractField {
    setDrawMode(type) {
        this.hide();
    }

    populate(element) {
        if (this.selection.length > 1) {
            this.deleteButton.hide();
            this.deleteAllButton.show();
        } else {
            this.deleteButton.show();
            this.deleteAllButton.hide();
        }
    }

    make() {
        this.field = this.p.createDiv()
            .class('input-group')
            .style('margin-top', '15px');
        this.buttons = this.p.createDiv()
            .class('row row-between')
            .parent(this.field);
        this.deleteButton = this.p.createButton('Delete')
            .class('btn-danger')
            .style('margin-left', '5px')
            .mousePressed(() => this.selection.delete())
            .parent(this.buttons);
        this.deleteAllButton = this.p.createButton('Delete all')
            .class('btn-danger')
            .style('margin-left', '5px')
            .attribute('title', 'Delete all selected elements')
            .mousePressed(() => this.selection.delete())
            .parent(this.buttons);
        this.initialized = true;
        return this;
    }

    all() {
        this.deleteButton.hide();
        this.deleteAllButton.show();
    }
}
